import { createSelector } from '@reduxjs/toolkit';

import { CarsParameters } from '@/features/cars/types';
import immutableFilterQueriesSelector from '@/features/filters/selectors/immutableQueries';
import filterQueriesSelector from '@/features/filters/selectors/queries';

import optionsSelector from './options';

const parametersSelector = createSelector(
  [optionsSelector, immutableFilterQueriesSelector, filterQueriesSelector],
  (options, immutableQueries, queries) => {
    const parameters: Required<Pick<CarsParameters, 'options' | 'filter'>> = {
      options: { options },
      filter: {
        q: [...immutableQueries.q, ...queries.q],
      },
    };
    return parameters;
  },
);

export default parametersSelector;
